import { render, staticRenderFns } from "./order-divvy-dialog.vue?vue&type=template&id=4a4dc276&scoped=true&"
import script from "./order-divvy-dialog.vue?vue&type=script&lang=js&"
export * from "./order-divvy-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4dc276",
  null
  
)

export default component.exports